module.exports = __webpack_public_path__ + "img/sq.d76baaa2.png";